<svg viewBox="0 0 32 32" 
    xmlns="http://www.w3.org/2000/svg">
    <path fill="currentColor" d="M8 26h17V5H8v21zm0 1v3h17v-3H8zM8 4h17V2H8v2zm0-4h17a2 2 0 0 1 2 2v28a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm7 29a.5.5 0 1 1 0-1h3a.5.5 0 1 1 0 1h-3zm-4.118-11.177a.5.5 0 1 1-.764-.646l8.457-10a.5.5 0 1 1 .764.646l-8.457 10zm0-5a.5.5 0 1 1-.764-.646l3.875-4.581a.5.5 0 0 1 .763.646l-3.874 4.58z"/>
</svg>
